import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=da969768&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style0 from "@/sass/06_atoms/button.scss?vue&type=style&index=0&id=da969768&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da969768",
  null
  
)

export default component.exports